import { render, staticRenderFns } from "./crudServices.vue?vue&type=template&id=a5d8b87c&scoped=true&"
import script from "./crudServices.vue?vue&type=script&lang=js&"
export * from "./crudServices.vue?vue&type=script&lang=js&"
import style0 from "./crudServices.vue?vue&type=style&index=0&id=a5d8b87c&prod&lang=css&"
import style1 from "./crudServices.vue?vue&type=style&index=1&id=a5d8b87c&prod&scoped=true&lang=css&"
import style2 from "./crudServices.vue?vue&type=style&index=2&id=a5d8b87c&prod&lang=css&"
import style3 from "./crudServices.vue?vue&type=style&index=3&id=a5d8b87c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d8b87c",
  null
  
)

export default component.exports